import { resolvePageSection } from '~/composables/usePageSection'
import { useViewItemPosition } from '~/composables/useViewItemPosition'

/**
 * Captures the page the user navigated from when entering a product detail page,
 * so the PDP `view_item` tracker can report the correct origin `page_section`
 * even for entry points that did not record it per-product.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { setOriginSection } = useViewItemPosition()

  router.beforeEach((to, from) => {
    if (resolvePageSection(to.path) !== 'product')
      return

    // Ignore the initial app load / direct navigation (no real previous route),
    // so direct PDP visits fall back to the current route section instead.
    if (!from.matched.length)
      return

    setOriginSection(resolvePageSection(from.path))
  })
})
